import * as sharedActions from '../../../../../shared/store/collections/actions';

export const setAllCollections = sharedActions.setAllCollections;

export const fetchAllCollections = sharedActions.fetchAllCollections;
